import DateTime from "utils/DateTime";
import Timespan from "utils/Timespan";
import WorkBlock from "./WorkBlock";
import WorkOrder from "./WorkOrder";

const Schedule = {
  recalculateRemainingDuration,
  remainingDuration: remainingWorkOrderDuration,
  remainingDurationForBrandNewWorkBlock,
  resizedQuantity,
  shrinkTimeSpanToWorkOrderRemaining,
  snapRemainingDuration,
};

export const SNAPPING_THRESHOLD = 10 * 60;

function remainingDurationForBrandNewWorkBlock(workBlock) {
  const {
    workOrder,
    workOrder: { unscheduledQuantity },
  } = workBlock;

  if (_isCompletedOrCancelled(workOrder)) return 0;

  const quantityToBeScheduled = WorkBlock.pendingScheduledQuantity(workBlock);

  return (
    ((unscheduledQuantity - quantityToBeScheduled) / WorkBlock.effectiveProductionRate(workBlock)) *
    DateTime.hoursToSeconds(1)
  );
}
function remainingWorkOrderDuration(newWorkBlock, quantityDelta) {
  const {
    workOrder,
    workOrder: { unscheduledQuantity },
  } = newWorkBlock;

  if (_isCompletedOrCancelled(workOrder)) return 0;

  return (
    ((unscheduledQuantity + quantityDelta) / WorkBlock.effectiveProductionRate(newWorkBlock)) *
    DateTime.hoursToSeconds(1)
  );
}

function recalculateRemainingDuration({ workBlock, newWorkBlock }) {
  const oldQuantity = WorkBlock.pendingScheduledQuantity(workBlock);
  const newQuantity = WorkBlock.pendingScheduledQuantity(newWorkBlock);

  const quantityDelta = oldQuantity - newQuantity;

  return remainingWorkOrderDuration(newWorkBlock, quantityDelta);
}

function resizedQuantity(workBlock, newWorkTimeStartsAt, newWorkTimeEndsAt) {
  const updatedWorkblock = {
    ...workBlock,
    workTimeEndsAt: newWorkTimeEndsAt,
    workTimeStartsAt: newWorkTimeStartsAt,
  };

  return WorkBlock.quantity(updatedWorkblock);
}

function snapRemainingDuration(inputRemainingDuration) {
  if (inputRemainingDuration >= -SNAPPING_THRESHOLD && inputRemainingDuration <= SNAPPING_THRESHOLD) {
    return 0;
  }

  return inputRemainingDuration;
}

function shrinkTimeSpanToWorkOrderRemaining({ remainingBlockDuration, timespan, existingBlock }) {
  const overscheduled = remainingBlockDuration < 0;
  let { endTime } = timespan;

  if (existingBlock && overscheduled) {
    endTime = DateTime.addDurationDate(timespan.startTime, WorkBlock.workTimeDuration(existingBlock), "seconds");
  }

  if (timespan.durationInSeconds() > remainingBlockDuration && !overscheduled) {
    endTime = DateTime.addDurationDate(timespan.startTime, remainingBlockDuration, "seconds");
  }

  return new Timespan(new Date(timespan.startTime), endTime);
}

function _isCompletedOrCancelled(workOrder) {
  return WorkOrder.isCompleted(workOrder) || WorkOrder.isCancelled(workOrder);
}

export default Schedule;
